module.exports = __webpack_public_path__ + "static/media/icon.ec25a72b.png";